import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"28px","text-align":"center","font-weight":"bold","margin-bottom":"32px"} }, " 个案处理摘要 ", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { style: {"font-size":"26px","border":"2px dashed #c0bec7","margin-top":"32px","padding":"24px 32px"} }

import { useTable } from '../../../hooks/use-table';
import { data_4_1 } from '../../../hooks/use-preview';

const className = 'case-table-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-case-6',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;

const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", { innerHTML: _unref(html) }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data_4_1).resultSystem), 1)
  ]))
}
}

})